import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79b2cf78"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  playsInline: "",
  id: "containerVideo",
  class: "player-preview__background"
}, null, -1))
const _hoisted_2 = { class: "player-actions__series-wrapper full-width d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "player-actions__button pr-20 d-flex justify-center"
}
const _hoisted_4 = {
  key: 0,
  class: "player-actions__info"
}
const _hoisted_5 = { class: "full-screen" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "category"
}
const _hoisted_8 = {
  key: 2,
  class: "controls mb-20"
}
const _hoisted_9 = { class: "control-left" }
const _hoisted_10 = {
  key: 0,
  class: "control-right"
}
const _hoisted_11 = { class: "btn_group p-relative" }
const _hoisted_12 = {
  key: 3,
  class: "progress mb-30"
}
const _hoisted_13 = { class: "progress-time__current" }
const _hoisted_14 = { class: "progress-time__ended" }

import { computed, onUnmounted, ref, watch } from 'vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'
import SeriesSlider from '@/components/Sliders/SeriesSlider.vue'
import Popper from 'vue3-popper'
import { useRoute } from 'vue-router'
import { usePlayerStore } from '@/stores/player'
import { likeUpdateById } from '@/api'
import { useShare } from '@vueuse/core'
import { isClient } from '@vueuse/shared'
import { API_MEDIA, METRIKA_TARGET_PLAY_BTN } from '@/helpers/globalVars'
import Hls from 'hls.js'
import { formatTime } from '@/helpers/'
import OverLayLoader from '@/components/Loaders/OverLayLoader.vue'
import { useYandexMetrika } from 'yandex-metrika-vue3'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainPlayer',
  setup(__props) {

const isOverLayHidden = ref(false)
const overLayCounter = ref(0)
const isLoader = ref(true)

const options = ref({
  title: 'YKVIK.COM',
  text: '',
  url: isClient ? location.href : ''
})
const openShare = () => {
  return share().catch(err => console.log('Share Error', err))
}
const likeUpdate = async () => {
  try {
    isLiked.value = await likeUpdateById(route.params.media as string)
  } catch (error) {
    console.log(error)
  }
}
const fullScreen = () => {
  const requestFullScreen = (element) => {
    const requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
    if (requestMethod) {
      requestMethod.call(element)
    }
  }
  if (document.fullscreenElement) {
    document.exitFullscreen()
  } else {
    const wrapper = document.getElementsByClassName('player-layout')[0]
    requestFullScreen(wrapper)
  }
}
const parseTime = (time: number) => {
  const hasHours = (media.value.time.fullTime / 3600) >= 1.0
  return formatTime(time, hasHours)
}
const setTime = (e) => {
  showControls()
  try {
    const bcr = e.target.getBoundingClientRect()
    const containerVideo = document.getElementById('containerVideo')
    const wrapperProgress = document.getElementById('wrapperProgress')
    const currentPosition = e.type.includes('touch') ? e.targetTouches[0].clientX - bcr.x : e.offsetX
    if (currentPosition / wrapperProgress.offsetWidth <= 0.99) {
      containerVideo.currentTime = (currentPosition / wrapperProgress.offsetWidth) * media.value.time.fullTime
    }
  } catch (e) {
    console.log('Error', e)
  }
}
const volumeChange = () => {
  const containerVideo = document.getElementById('containerVideo')
  containerVideo.muted = !containerVideo.muted
}
const showControls = () => {
  isOverLayHidden.value = false
  overLayCounter.value = 0
}
const { share, isSupported } = useShare(options)
const route = useRoute()
const playerStore = usePlayerStore()

const media = computed(() => playerStore.info)
const likes = ref(0)
const isLiked = ref(null)

const hls = ref(new Hls())
watch(media, (value, oldValue) => {
  if (!value?.playlist_id) {
    return undefined
  }
  const containerVideo = document.getElementById('containerVideo')
  if (value.playlist_id !== oldValue.playlist_id) {
    hls.value.loadSource(`${API_MEDIA}${value.bitrate.list[value.bitrate.current]}`)
    hls.value.attachMedia(containerVideo)
    hls.value.on(Hls.Events.MEDIA_ATTACHED, function () {
      isLoader.value = false
      isLiked.value = null
      containerVideo.muted = value.status.isMuted
      containerVideo.addEventListener('canplaythrough', async () => {
        await containerVideo.play()
          .then(() => playerStore.setPlay(true))
          .catch(err => console.log('Error start auto play', err))
      })
      containerVideo.addEventListener('play', function () {
        playerStore.setPlay(true)
        try {
          const yandexMetrika = useYandexMetrika()
          yandexMetrika.reachGoal(METRIKA_TARGET_PLAY_BTN)
        } catch (e) {
          console.log('Metrika error', e)
        }
      })
      containerVideo.addEventListener('pause', function () {
        playerStore.setPlay(false)
      })
      containerVideo.addEventListener('timeupdate', () => {
        playerStore.setFullTime(containerVideo.duration)
        playerStore.setCurrentTime(containerVideo.currentTime)
        if (!isOverLayHidden.value) {
          try {
            const wrapperProgress = document.getElementById('wrapperProgress')
            const progressFullWidth = wrapperProgress.offsetWidth ?? 0
            const progress = Math.floor(media.value.time.current) / Math.floor(media.value.time.fullTime)
            playerStore.setProgress(Math.floor(progress * progressFullWidth))
          } catch (e) {
            console.log('Progress update error')
          }
          overLayCounter.value += 1
          if (overLayCounter.value >= 15) {
            isOverLayHidden.value = true
          }
        }
      })
      containerVideo.addEventListener('volumechange', function () {
        playerStore.toggleMute(containerVideo.muted)
      })
      containerVideo.addEventListener('error', function (e) {
        console.log('Error play', e)
        playerStore.setPlay(false)
      })
    })
  }
  if (value.status.isPlaying !== oldValue.status.isPlaying) {
    value.status.isPlaying ? containerVideo.play() : containerVideo.pause()
  }
  if (oldValue.bitrate.current && value.bitrate.current !== oldValue.bitrate.current) {
    isLoader.value = true
    const selectBitrate = value.bitrate.list[value.bitrate.current]
    const time = media.value.time.current
    hls.value.loadSource(`${API_MEDIA}${selectBitrate}`)
    containerVideo.currentTime = time
    isLoader.value = false
  }
})
watch(() => route.params.media, (newId) => {
  playerStore.$reset()
  overLayCounter.value = 0
  isLoader.value = true
  playerStore.fetchMedia(newId)
})
onUnmounted(() => {
  playerStore.$reset()
  overLayCounter.value = 0
})
playerStore.fetchMedia(route.params.media as string)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_touch = _resolveDirective("touch")!
  const _directive_touch_class = _resolveDirective("touch-class")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(OverLayLoader, null, null, 512), [
          [_vShow, isLoader.value]
        ])
      ]),
      _: 1
    }),
    (_openBlock(), _createElementBlock("div", {
      onClick: showControls,
      class: "player",
      key: _unref(route).params.media
    }, [
      _hoisted_1,
      _createElementVNode("div", {
        class: _normalizeClass(["player-actions", [isOverLayHidden.value ? 'play' : 'info pause']])
      }, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_2, [
              (media.value?.episodes_list)
                ? (_openBlock(), _createBlock(SeriesSlider, {
                    key: 0,
                    seriesList: media.value.episodes_list
                  }, null, 8, ["seriesList"]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, !isOverLayHidden.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (!isOverLayHidden.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (media.value.status.isLoaded)
                    ? (_openBlock(), _createBlock(CircleButton, {
                        key: 0,
                        onClick: _unref(playerStore).toggleStateVideo,
                        class: "btn-player__action",
                        name: media.value?.status.isPlaying ? 'pause' : 'play',
                        iconWidth: 47,
                        iconHeight: 47,
                        "view-box": "0 0 28.58 39.49"
                      }, null, 8, ["onClick", "name"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (!isOverLayHidden.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (media.value.status.isLoaded)
                      ? (_openBlock(), _createBlock(CircleButton, {
                          key: 0,
                          onClick: fullScreen,
                          name: "resize-full",
                          iconWidth: 24,
                          iconHeight: 24,
                          "view-box": "0 0 24 24"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (media.value.status.isLoaded)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(media.value?.title) + " - " + _toDisplayString(media.value?.episode_num) + " серия", 1))
                    : _createCommentVNode("", true),
                  (media.value.status.isLoaded)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(media.value?.episode_spec), 1))
                    : _createCommentVNode("", true),
                  (media.value.status.isLoaded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(CircleButton, {
                            onClick: likeUpdate,
                            name: !isLiked.value ? 'like' : 'saved-like',
                            iconWidth: 18,
                            iconHeight: 15.96,
                            "view-box": "0 0 18 15.96"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(likes.value && !isLiked.value ? '' : isLiked.value), 1)
                            ]),
                            _: 1
                          }, 8, ["name"])
                        ]),
                        (media.value.status.isLoaded)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(CircleButton, {
                                onClick: volumeChange,
                                name: media.value?.status.isMuted ? 'mute' : 'volume',
                                iconWidth: 16,
                                iconHeight: 18,
                                "view-box": "0 0 16 18"
                              }, null, 8, ["name"]),
                              (_unref(isSupported))
                                ? (_openBlock(), _createBlock(CircleButton, {
                                    key: 0,
                                    onClick: openShare,
                                    name: "upload",
                                    iconWidth: 16,
                                    iconHeight: 18,
                                    "view-box": "0 0 16 18"
                                  }))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_unref(Popper), {
                                  interactive: true,
                                  class: "popper"
                                }, {
                                  content: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(media.value?.bitrate.list, (encode, bitrate) => {
                                      return (_openBlock(), _createBlock(CircleButton, {
                                        class: "mb-10",
                                        bg: bitrate == media.value?.bitrate.current ? 'gradient2':'border',
                                        onClick: ($event: any) => (_unref(playerStore).setBitrate(parseInt(bitrate))),
                                        key: encode,
                                        popovertarget: "encodes_list",
                                        name: "empty"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(bitrate) + "p", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["bg", "onClick"]))
                                    }), 128))
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(CircleButton, { name: "empty" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(media.value?.bitrate.current) + "p", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              (media.value?.playlist_id && media.value?.episode_num)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: {name: 'project', params: {id: media.value?.playlist_id}, query: {series: media.value?.episode_num}}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(CircleButton, {
                                        name: "chevron-down",
                                        iconWidth: 16,
                                        iconHeight: 18,
                                        "view-box": "0 0 16 18"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (media.value.status.isLoaded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(parseTime(media.value?.time.current)), 1),
                        _withDirectives((_openBlock(), _createElementBlock("div", {
                          draggable: "true",
                          onDrag: setTime,
                          onDragend: setTime,
                          onClick: setTime,
                          id: "wrapperProgress",
                          class: "progress-bar"
                        }, [
                          _createElementVNode("span", {
                            style: _normalizeStyle({ width: `${media.value?.progress.width}px` }),
                            class: "current"
                          }, null, 4)
                        ], 32)), [
                          [_directive_touch, setTime, "drag"],
                          [_directive_touch_class, 'touched']
                        ]),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(parseTime(media.value?.time.fullTime)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]))
  ], 64))
}
}

})